<app-header></app-header>
<main role="main" class="maincnt mainmrg">
  <div class="bannersect sectppad pb-2">
    <div class="sectpad homesectpadd container">
      <div class="bannertxt col-12">
        <h1>
          Shop for energy,
          <br />
          save with confidence
        </h1>
        <div class="bannerdesc">
          No frills. No gimmicks.
          <font class="subdesc">Just honest recommendations.</font>
        </div>
        <div>
          <a
            href="javascript:void(0)"
            class="shopnow shopnowls"
            (click)="clickShopNow()"
            >SHOP NOW</a
          >
          <a
            href="#/"
            data-toggle="modal"
            data-target="#myModal"
            class="seework ml-3"
            >SEE HOW IT WORKS</a
          >
          <div class="smalldesc mt-2 businessfntwgt">
            Business owners: click
            <a href="javascript:void(0)" routerLink="/commercial"> here</a> to
            get a custom quote
          </div>
        </div>
      </div>
      <div class="bannerimg col-12 text-center">
        <img
          src="https://res.cloudinary.com/honest-gorilla/image/upload/v1570605090/Static%20images/bannerimg1_nguhaf.svg"
          alt="Landscape city view illustration of various office buildings, school and a playground set"
          title="Landscape city view illustration for residential energy"
          width="100%"
          class="img-responsive webimg drag-drop"
        />
        <img
          src="https://res.cloudinary.com/honest-gorilla/image/upload/v1570605072/Static%20images/bannerimg2_z1ncdr.svg"
          width="100%"
          alt="Landscape city view illustration of various office buildings, school and a playground set"
          title="Landscape city view illustration for residential energy"
          class="img-responsive mobimg"
        />
      </div>
    </div>
  </div>
  <div class="sponsersect">
    <div class="sectpad container-fluid text-center">
      <span
        ><img
          src="assets/images/sponser1C.png"
          loading="lazy"
          alt="4Change Energy"
          class="img-responsive drag-drop"
      /></span>
      <span
        ><img
          src="assets/images/sponser2g.png"
          loading="lazy"
          alt="Gexa Energy"
          class="img-responsive drag-drop"
      /></span>
      <span
        ><img
          src="assets/images/sponser3F.png"
          loading="lazy"
          alt="Frontier Utilities"
          class="img-responsive drag-drop"
      /></span>
      <span
        ><img
          src="assets/images/sponserc4.png"
          alt="Chariot Energy"
          class="img-responsive drag-drop"
          loading="lazy"
      /></span>
      <span
        ><img
          src="assets/images/sponser5p.png"
          alt="Pulse Power"
          class="img-responsive drag-drop"
          loading="lazy"
      /></span>
      <span
        ><img
          src="assets/images/sponser6N.png"
          alt="New Power Texas"
          class="img-responsive drag-drop"
          loading="lazy"
      /></span>
      <span
        ><img
          src="assets/images/sponser7P.png"
          loading="lazy"
          alt="Pronto Power"
          class="img-responsive drag-drop"
      /></span>
      <span
        ><img
          src="assets/images/sponser8b.png"
          loading="lazy"
          alt="Bulb"
          class="img-responsive drag-drop"
      /></span>
    </div>
  </div>

  <div class="madeshopsect" id="shopSection">
    <div class="container">
      <div class="sectpad container text-center row m-0 section">
        <div class="col-12 col-sm-7 subsect text-left mob-mt-20">
          <h2>
            Shopping for energy<br />
            made simple
          </h2>
          <p class="desc mb-0">
            We do all the number crunching so that you can easily and quickly
            comparison shop for energy, signup and save.
          </p>
          <!-- <a class="btn mr-2 ml-2 sectbtn float-left webview" href="javascript:void(0)">LEARN MORE</a> -->
        </div>
        <div class="col-12 col-sm-5 subsect madshopimage">
          <img
            src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569478681/Static%20images/Residential%20images/madeshopimg_xdkv91.svg"
            alt="Illustration of chatbot conversation and chart analysis"
            title="Residential energy web view"
            class="webview drag-drop"
            width="274"
          />
          <img
            src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569478699/Static%20images/Residential%20images/madeshopimg2_hvbhg3.svg"
            alt="Illustration of chatbot conversation and chart analysis"
            title="Residential energy mobile view"
            class="mobileview mx-auto d-block drag-drop"
            width="250"
          />
        </div>
        <!-- <a class="btn mr-2 ml-2 sectbtn float-left mobileview" href="javascript:void(0)">LEARN MORE</a> -->
      </div>
    </div>
  </div>

  <div class="gorillaworksect">
    <div class="container">
      <div class="sectpad container row m-0 section pb-5 mob-pt-20">
        <div class="col-sm-6 subsect">
          <h2>How Honest Gorilla Works</h2>
          <p class="hgdesc fs22">
            Eva, our chatbot, will ask a few questions to better understand your
            household, lifestyle, and budget. Consider it a soft home energy
            audit to get you to think of additional ways to save money. We then
            recommend an energy plan that meets your needs. Pretty simple.
          </p>
          <p class="hgdesc fs22">
            The brilliant minds at Honest Gorilla have reverse-engineered every
            portfolio energy company's pricing plans so that you don't waste any
            time trying to figure it all out on your own.
          </p>
          <p class="hgdesc fs22">
            Let Honest Gorilla be your advocate and go to work for you. Because
            if it makes sense, it saves you dollars.
          </p>
          <p></p>
          <p class="hgdesc fs22">
            No more guesswork or spreadsheets. No more overpaying or frustration
            shopping for energy. Just honest recommendations. Shop today and
            save.
          </p>
        </div>
        <div class="col-sm-6 subsect">
          <div class="col-sm-12 row m-0 mb-4 hgpadding">
            <div
              class="col-sm-5 col-5 pl-2 drag-drop sectimg align-self-center"
            >
              <img
                src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569478802/Static%20images/Residential%20images/worksimg1_duiead.svg"
                alt="Illustration of household electronic appliances, including tv, iPad, lamp"
                title="Common household electronics illustration"
                width="131"
              />
            </div>
            <div
              class="col-sm-7 col-7 align-self-center listdesc text-left fs20"
            >
              Choose an energy plan that fits your budget and lifestyle.
            </div>
          </div>
          <div class="col-sm-12 row m-0 mb-4 hgpadding">
            <div
              class="col-sm-5 col-5 px-0 drag-drop sectimg align-self-center"
            >
              <img
                src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569478823/Static%20images/Residential%20images/worksimg2_k4l4ch.svg"
                alt="Illustration of a tally showing that as more customers sign up, the more money Honest Gorilla will contribute toward its giveback program"
                title="Giveback tally increasing"
                width="137"
              />
            </div>
            <div
              class="col-sm-7 col-7 align-self-center listdesc webview text-left fs20"
            >
              Once a year, we will tally up our profits and recommend to the
              board how much we'd like to
              <a class="underLine" routerLink="/giveback">give back.</a>
            </div>
            <div
              class="col-sm-7 col-7 align-self-center listdesc mobileview text-left"
            >
              Once a year, we will tally up our profits and recommend to the
              board how much we'd like to giveback.
            </div>
          </div>
          <div class="col-sm-12 row m-0 mb-4 hgpadding">
            <div
              class="col-sm-5 col-5 pl-0 drag-drop sectimg align-self-center"
            >
              <img
                src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569478833/Static%20images/Residential%20images/worksimg3_ffpcvg.svg"
                alt="Light of Unity logo hot air balloon illustration in the clouds"
                title="Light of Unity logo hot air balloon illustration"
                width="119"
              />
            </div>
            <div
              class="col-sm-7 col-7 align-self-center listdesc text-left fs20"
            >
              We giveback a certain percentage of our profits to
              <a class="underLine" routerLink="/giveback">
                give back shed the light of unity</a
              >.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="homewanttosect">
    <div class="container">
      <div class="sectpad container-fluid row m-0 section">
        <div class="col-sm-6 subsect pb-3 mob-mt-50">
          <h2 class="font39">Want to Lower Your Energy Bills?</h2>
          <p class="desc homesectpad">
            Customers from these companies relied on Honest Gorilla to find them
            a better deal.
          </p>
          <a
            class="shopnow shopnowls webview"
            style="line-height: 2 !important"
            routerLink="/residentialQues"
            href="javascript:void(0)"
            >SHOP NOW</a
          >
        </div>
        <div class="col-sm-6 subsect text-center pb-3 energyimage px-2">
          <img
            src="https://res.cloudinary.com/honest-gorilla/image/upload/v1580819928/Static%20images/energy11_trqwj7.png"
            alt="5 bubbles showing various retail electric providers and the percentage of our customers who switched away from them"
            title="REPs that customers previously used"
            class="img-responsive energyimg1 drag-drop"
          />
          <img
            src="https://res.cloudinary.com/honest-gorilla/image/upload/v1580819827/Static%20images/energy1_c8gsdz.png"
            alt="5 bubbles showing various retail electric providers and the percentage of our customers who switched away from them"
            title="REPs that customers previously used"
            class="img-responsive energyimg2 drag-drop mb-3"
          />
          <a
            class="shopnow shopnowls mobileview mobileshpnowmb"
            routerLink="/residentialQues"
            href="javascript:void(0)"
            >SHOP NOW</a
          >
        </div>
      </div>
    </div>
  </div>
</main>

<!-- Modal -->
<div
  class="modal fade"
  data-backdrop="static"
  data-keyboard="false"
  id="myModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog videopopup p-2" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <button
          type="button"
          class="close videoclose"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closebootvideo()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="embed-responsive embed-responsive-16by9">
          <iframe
            class="embed-responsive-item"
            src="https://www.youtube.com/embed/h9KzDUEXJZ0"
            id="video"
            allowscriptaccess="always"
            >></iframe
          >
        </div>
      </div>
    </div>
  </div>
</div>

<!--chat-sec-->

<button
  class="src-component-launcher-WidgetLauncher-wrapper helpbtn"
  (click)="help()"
>
  <span
    class="src-component-Icon-container Icon fa fa-question-circle"
    type="Icon"
  >
  </span>
  <span class="src-component-launcher-WidgetLauncher-label">Help</span>
</button>
<!-- <div class="chat-box-sec">
    <app-help></app-help>
</div> -->
<app-help></app-help>
<app-footer></app-footer>
